import React from 'react';
import { Navigate } from 'react-router-dom';
import CandidateLayout from './CandidateLayout';

interface CandidateProtectedRouteProps {
  children: React.ReactNode;
}

const CandidateProtectedRoute: React.FC<CandidateProtectedRouteProps> = ({ children }) => {
  const candidateToken = localStorage.getItem('candidateToken');

  if (!candidateToken) {
    return <Navigate to="/candidate-login" replace />;
  }

  return (
    <CandidateLayout>
      {children}
    </CandidateLayout>
  );
};

export default CandidateProtectedRoute;


